// Imports
import Vue from 'vue'
import Router from 'vue-router'
import {
  layout,
  route,
} from '@/util/routes'
// import { trailingSlash } from '@/util/helpers'
// import Welcome from "@/views/Welcome";
import { jwtDecode } from "jwt-decode";
import Swal from 'sweetalert2'
import store from '@/store'
import France30 from '../views/France30.vue';

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior: (to, from, savedPosition) => {
    if (to.hash) return { selector: to.hash }
    if (savedPosition) return savedPosition

    return { x: 0, y: 0 }
  },
  routes: [
    layout('Default', [
      route('Home'),
      route('Dashboard', null, 'Dashboard'),
      route('Prototype', null, 'Prototype'),
      route('ANR', null, 'ANR'),
      route('France30', null, 'France30'),
      route('Deeptech', null, 'Deeptech'),
      route('ValoRecherche', null, 'ValoRecherche'),
      route('GrandEst', null, 'GrandEst'),
      route('Europe', null, 'Europe'),
      route('Login', null, 'Login'),
      route('Logout', null, 'Logout'),
      route('Register', null, 'Register'),
      route('Confirm', null, 'Confirm'),
      route('Rgpd', null, 'Rgpd'),
      route('Visualize', null, 'Visualize/:id'),
      route('ResetPassword', null, 'ResetPassword'),
      route('AdminPage', null, 'AdminPage'),
      route('Account', null, 'Account'),
    ]),
  ],
})

router.beforeEach((to, from, next) => {
  const currentRoute = to.path.toLowerCase()
  // all route in lower case for easier comparison
  const publicPages = ['/confirm', '/login', '/register', '/home', '/', '/confirm', '/rgpd', "/resetpassword"]
  const paidPages = ['/anr', '/grandest', '/europe', '/france30', '/deeptech', '/valorecherche']
  const adminPages = ['/adminpage']
 // const authRequired = ['/Dashboard', '/Prototype']
  const routeIsPublic = publicPages.includes(currentRoute)
  let loggedIn = localStorage.getItem('user')
  if (loggedIn) {
    const decodedToken = jwtDecode(JSON.parse(localStorage.getItem('user')).accessToken)
    const tokenExp = decodedToken.exp
    const currentTime = Math.floor(Date.now()/1000)
    if (tokenExp < currentTime){
      store.dispatch('auth/logout')
      console.log("loggedout : token expired")
      loggedIn = false
    }
  }
  // trying to access a restricted page + not logged in
  // redirect to login page
  if (routeIsPublic){
    next()
  }else if (!routeIsPublic && !loggedIn) {
    console.log("pushed from index : ", currentRoute, "; NOT IDENTIFIED")
    next('/Login')
  } 
  else if (!routeIsPublic && loggedIn) {
    // try {
    //   jwt.verify(JSON.parse(localStorage.getItem('user')).accessToken, process.env.VUE_APP_JWT_SECRET);
    // }catch (e) {
    //   Swal.fire('Erreur', 'Token de connexion invalide, veuillez vous reconnecter.', 'error');
    //   console.log("error : ", e)
    // }
    const decodedToken = jwtDecode(JSON.parse(localStorage.getItem('user')).accessToken)
    if (paidPages.includes(currentRoute) && !decodedToken.authorities.basic){
      Swal.fire('Erreur', 'Vous n\'avez pas les droits nécessaire pour acceder à ce contenu.', 'error');
      next(from)
    }else if (adminPages.includes(currentRoute) && decodedToken.role != "admin"){
      next(from)
    }else {
      next()
    }
  }else {
    next()
  }
})

export default router
